






































import { defineComponent } from '@vue/composition-api';
import { InputType } from '@getaccept/lib-ui';
import {
  identifyRecipientProps,
  useIdentifyRecipient,
} from '../composables/identify-recipient.composable';

export default defineComponent({
  name: 'IdentifyDsrRecipient',
  props: {
    ...identifyRecipientProps,
  },
  setup(props, { emit }) {
    const { documentName, email, handleClick, errorMessage } = useIdentifyRecipient(props, emit);
    return { documentName, email, handleClick, errorMessage, InputType };
  },
});
